import { useEffect, useState } from 'react';
import { Download, X } from 'lucide-react';
import { Button } from '@/components/ui/button';

interface BeforeInstallPromptEvent extends Event {
  prompt: () => Promise<void>;
  userChoice: Promise<{ outcome: 'accepted' | 'dismissed' }>;
}

const DISMISS_KEY = 'visep-pwa-dismissed';

export function PWAInstallBanner() {
  const [promptEvent, setPromptEvent] = useState<BeforeInstallPromptEvent | null>(null);

  useEffect(() => {
    if (localStorage.getItem(DISMISS_KEY) === '1') return;
    const onPrompt = (e: Event) => {
      e.preventDefault();
      setPromptEvent(e as BeforeInstallPromptEvent);
    };
    window.addEventListener('beforeinstallprompt', onPrompt);
    return () => window.removeEventListener('beforeinstallprompt', onPrompt);
  }, []);

  if (!promptEvent) return null;

  function dismiss() {
    localStorage.setItem(DISMISS_KEY, '1');
    setPromptEvent(null);
  }

  async function install() {
    if (!promptEvent) return;
    await promptEvent.prompt();
    await promptEvent.userChoice;
    setPromptEvent(null);
  }

  return (
    <aside
      aria-label="Instalar aplicación"
      className="safe-bottom fixed inset-x-0 bottom-0 z-40 border-t border-white/[0.08] bg-[#060B16]/95 backdrop-blur"
    >
      <div className="container flex items-center justify-between gap-4 py-3">
        <div className="flex items-center gap-3">
          <Download className="h-5 w-5 text-primary" aria-hidden />
          <p className="text-sm">Instalá la App VISEP para un acceso más rápido.</p>
        </div>
        <div className="flex items-center gap-2">
          <Button size="sm" onClick={install}>
            Instalar
          </Button>
          <button
            type="button"
            onClick={dismiss}
            aria-label="Descartar"
            className="min-touch-target inline-flex items-center justify-center text-slate-400 hover:text-white"
          >
            <X className="h-5 w-5" />
          </button>
        </div>
      </div>
    </aside>
  );
}
